import React, { useState } from 'react';
import { mockCases } from '../data/mockData';

export default function CaseDetail({ caseId, onBack }) {
    const caseData = mockCases.find((c) => c.id === caseId);

    const [status, setStatus] = useState(caseData?.status || '');
    const [notes, setNotes] = useState('');

    if (!caseData) return <p>Case not found</p>;

    return (
        <div className="case-detail">
            <button onClick={onBack} className="back-btn">
                ← Back to Dashboard
            </button>

            <div className="detail-header">
                <h2>
                    Case #{caseData.id}: {caseData.customerName}
                </h2>
                <span
                    className={`status-badge ${status
                        .toLowerCase()
                        .replace(' ', '-')}`}
                >
                    {status || caseData.status}
                </span>
            </div>

            <div className="detail-grid">
                <div className="detail-card">
                    <h3>Case Information</h3>
                    <p>
                        <strong>Amount Owed:</strong> $
                        {caseData.amountOwed.toLocaleString()}
                    </p>
                    <p>
                        <strong>Days Overdue:</strong> {caseData.daysOverdue} days
                    </p>
                    <p>
                        <strong>Priority Score:</strong>{' '}
                        {caseData.priorityScore.toFixed(1)}/10
                    </p>
                    <p>
                        <strong>Assigned DCA:</strong> {caseData.assignedDCA}
                    </p>
                    <p>
                        <strong>Created Date:</strong> {caseData.createdDate}
                    </p>
                </div>

                <div className="detail-card">
                    <h3>Update Status</h3>
                    <select
                        value={status || caseData.status}
                        onChange={(e) => setStatus(e.target.value)}
                        className="status-select"
                    >
                        <option value="Assigned">Assigned</option>
                        <option value="In Progress">In Progress</option>
                        <option value="Promised to Pay">Promised to Pay</option>
                        <option value="Closed">Closed</option>
                    </select>
                </div>
            </div>

            <div className="detail-card full-width">
                <h3>Timeline</h3>
                <div className="timeline">
                    <div className="timeline-item">
                        <span className="timeline-date">Jan 5, 2026</span>
                        <p>Case created and automatically prioritized</p>
                    </div>
                    <div className="timeline-item">
                        <span className="timeline-date">Jan 6, 2026</span>
                        <p>Assigned to {caseData.assignedDCA}</p>
                    </div>
                    <div className="timeline-item">
                        <span className="timeline-date">Jan 9, 2026</span>
                        <p>
                            Status: {caseData.status} (Last update: 3 days ago)
                        </p>
                    </div>
                </div>
            </div>

            <div className="detail-card full-width">
                <h3>Add Note</h3>
                <textarea
                    value={notes}
                    onChange={(e) => setNotes(e.target.value)}
                    placeholder="Add update or note about this case..."
                    rows="5"
                    className="notes-input"
                ></textarea>
                <button
                    className="save-btn"
                    onClick={() => alert('Note saved! (Demo)')}
                >
                    Save Note
                </button>
            </div>
        </div>
    );
}

